/** @format */

import React, { useState, useEffect, useCallback, useRef } from "react";
import { Resizable } from "re-resizable";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCoordinate,
  updateCoordinate,
} from "../../../store/reducers/pdfeditor/pdfCoordinatesSlice.js";
import {
  updateBoxSize,
  selectVariable,
} from "../../../store/reducers/pdfeditor/toolsModificationSlice.js";
import styled from "styled-components";
import SelectField from "./SelectField.js";
import { Box, Tooltip, Typography } from "@mui/material";
import Draggable from "react-draggable";
import { toast } from "react-toastify";
import zIndex from "@mui/material/styles/zIndex.js";
import { throttle } from "lodash";

const CustomBox = ({ coordinate, scale, enableDargging,addText, dimensions, specialField, setSpecialField, multiField, setMultiField , isSelected, onSelect,setSelectedBoxId}) => {
  const dispatch = useDispatch();
  const nodeRef = useRef(null);
  // const [flag, setFlag] = useState(true);
  // const [clickFlag, setClickFlag] = useState(false);
  const [isResized, setIsResized] = useState(false);
  const [position, setPosition] = useState({
    x: 0,
    y: 0,
    prex: parseInt(coordinate["x-coordinate"]) * scale,
    prey: parseInt(coordinate["y-coordinate"]) * scale,
  });
  const [isPosition, setIsPosition] = useState(false);
  const [active, setActive] = useState(false);
  const { currBoxSize, currVariable } = useSelector(
    (state) => state.toolsModification
  );
  const [isDraggingEnabled, setIsDraggingEnabled] = useState(false);
  const [isAddTextEnabled, setIsAddTextEnabled] = useState(false)
  const [boxSize, setBoxSize] = useState({
    width: coordinate.width || currBoxSize?.width,
    height: coordinate.height || currBoxSize?.height,
    // width: Math.floor(coordinate.width) || Math.floor(currBoxSize?.width),
    // height: Math.floor(coordinate.height) || Math.floor(currBoxSize?.height),
  });
  const [dragBoxDetails, setDragBoxDetails] = useState({});

  const { options } = useSelector((state) => state.selectOptions);
  const [selectedVariable, setSelectedVariable] = useState("");

  const widthPdf = dimensions?.width;
  const heightPdf = dimensions?.height;
  // console.log('widthPdf canvas', widthPdf, 'heightPdf canvas', heightPdf);
  useEffect(() => {
    setIsDraggingEnabled(enableDargging);
  }, [enableDargging]);

  useEffect(() => {
    onSelect();
  }, []);

  useEffect(() => {
    setIsAddTextEnabled(addText);
  }, [addText]);

  useEffect(() => {
    if (isResized) {
      let data = { ...boxSize };
      dispatch(updateCoordinate({ id: coordinate.id, newValue: data }));
      setIsResized(false);
    }
  }, [boxSize]);

  // useEffect(() => {
  //   console.log("dragboxdetails are...", dragBoxDetails);
  // }, [dragBoxDetails]);

  useEffect(() => {
    if (isPosition) {
      let data = {
        "x-coordinate":
          parseInt(coordinate["x-coordinate"]) + position.x / scale,
          // Math.floor(parseInt(coordinate["x-coordinate"]) + position.x / scale),
        "y-coordinate":
          parseInt(coordinate["y-coordinate"]) + position.y / scale,
          // Math.floor(parseInt(coordinate["y-coordinate"]) + position.y / scale),
      };

      dispatch(updateCoordinate({ id: coordinate.id, newValue: data }));
      setIsPosition(false);
    }
  }, [position]);

  const handleResizeStop = (e, direction, ref, d) => {

    setIsResized(true);
    setSpecialField(false)
    // Calculate the new size ===>

    const { width, height } = boxSize || {};
    const updatedCoordinates = {
      "x-coordinate": position.prex / scale,
      "y-coordinate": position.prey / scale,
    };
    const xCoord = updatedCoordinates["x-coordinate"] * scale;
    const yCoord = updatedCoordinates["y-coordinate"] * scale;

    console.log(
      "box resize data",
      "ycoord",
      yCoord,
      "boxheight",
      height + d.height,
      "heightpdf",
      heightPdf
    );
    console.log(
      "box resize data",
      "total is",
      heightPdf - 56,
      "with coordinate is",
      yCoord + height + d.height - 56
    );
    let isSpecialVariable;
    const variableName =
      dragBoxDetails?.variableName || currVariable?.variableName;
    if (variableName?.includes(".")) {
      isSpecialVariable = [
        "Add Stamp",
        "Dynamic Stamp",
        "Multi Signer Stamp",
        "digital_stamp",
        "watermark_image",
        "multi_signers",
      ].includes(variableName?.split(".")[0]);
    } else {
      isSpecialVariable = [
        "Add Stamp",
        "Dynamic Stamp",
        "Multi Signer Stamp",
        "digital_stamp",
        "watermark_image",
        "multi_signers",
      ].includes(variableName);
    }
    console.log("condition left", yCoord + height + d.height - 56);
    console.log(
      "condition right",
      heightPdf - 56 - heightPdf * 0.07,
      isSpecialVariable
    );
    if (
      isSpecialVariable &&
      (yCoord + height + d.height - 56 >=
        heightPdf - 56 - (heightPdf - 56) * 0.07 ||
        xCoord + width + d.width >= widthPdf - widthPdf * 0.07)
    ) {
      toast.error("Try resizing with small steps.");
      setBoxSize({
        width:boxSize.width,
        height: boxSize.height,
        // width:Math.floor(boxSize.width),
        // height: Math.floor(boxSize.height),
      });
      dispatch(
        updateBoxSize({
          width: boxSize.width,
          height: boxSize.height,
          // width: Math.floor(boxSize.width),
          // height: Math.floor(boxSize.height),
        })
      );
    } else {
      if (yCoord + height + d.height - 56 >= heightPdf - 56) {
        // console.log("box resize data", " yes limit exceed");
        setBoxSize({
          width: boxSize.width + d.width,
          height: boxSize.height,
          // width: Math.floor(boxSize.width + d.width),
          // height: Math.floor(boxSize.height),
        });
        dispatch(
          updateBoxSize({
            width: boxSize.width + d.width,
            height: boxSize.height,
            // width: Math.floor(boxSize.width + d.width),
            // height: Math.floor(boxSize.height),
          })
        );
      } else {
        setBoxSize({
          width: boxSize.width + d.width,
          height: boxSize.height + d.height,
          // width: Math.floor(boxSize.width + d.width),
          // height: Math.floor(boxSize.height + d.height),
        });
        dispatch(
          updateBoxSize({
            width: boxSize.width + d.width,
            height: boxSize.height + d.height,
            // width: Math.floor(boxSize.width + d.width),
            // height: Math.floor(boxSize.height + d.height),
          })
        );
      }
    }
  };

  // delete variable ====>
  const handleDeleteVariable = (id) => {
    dispatch(deleteCoordinate(id));
  };

  function checkSpecialOrNot(){
    let isSpecialVariable;
    // const variableName = currVariable?.variableName|| dragBoxDetails?.variableName ;
    const variableName = coordinate?.value || dragBoxDetails?.variableName || currVariable?.variableName;
    console.log("variableName for special is", variableName)
    if (variableName?.includes(".")) {
      isSpecialVariable = [
        "Add Stamp",
        "Dynamic Stamp",
        "Multi Signer Stamp",
        "digital_stamp",
        "watermark_image",
        "multi_signers",
      ].includes(variableName?.split(".")[0]);
    } else {
      isSpecialVariable = [
        "Add Stamp",
        "Dynamic Stamp",
        "Multi Signer Stamp",
        "digital_stamp",
        "watermark_image",
        "multi_signers",
      ].includes(variableName);
    }
    if(isSpecialVariable){
      return true;
    }
  }
  // Update Variable Data ====>
  const handleSelectBox = (coordinates) => {
    setDragBoxDetails(coordinates);
    dispatch(
      selectVariable({
        variable: coordinates.id,
        fontSize: coordinates?.fontSize,
        width: coordinate.width,
        height: coordinate.height,
        // width: Math.floor(coordinate.width),
        // height: Math.floor(coordinate.height),
        data_type: coordinate?.data_type,
        variableName: coordinates?.value,
        fontFamily: coordinates?.fontFamily,
        fontSpace: coordinates?.fontSpace,
      })
    );
    setActive(false);
  };
  const handleSelectBoxClick = (coordinates) => {
    setDragBoxDetails(coordinates);
    dispatch(
      selectVariable({
        variable: coordinates.id,
        fontSize: coordinates?.fontSize,
        width: coordinate.width,
        height: coordinate.height,
        // width: Math.floor(coordinate.width),
        // height: Math.floor(coordinate.height),
        data_type: coordinate?.data_type,
        variableName: coordinates?.value,
        fontFamily: coordinates?.fontFamily,
        fontSpace: coordinates?.fontSpace,
      })
    );
  };

  const handleMouseLeave = () => {
    // console.log("currVariableeeeeeeeeeee", currVariable);
    const filterOption = options?.filter(
      (option) => option.label === selectedVariable
      // (option) => option.label === currVariable?.variableName
    );
    let nested = false;
    if (filterOption[0]?.value?.values?.length > 0) {
      nested = true;
    }

    if (currVariable?.variableName !== undefined && nested === false) {
      if (active === false) {
        dispatch(selectVariable({}));
        setActive(true);
      }
    } else if (currVariable?.variableName?.includes(".") && nested === true) {
      if (active === false) {
        dispatch(selectVariable({}));
        setActive(true);
      }
    }
  };

  const iconStyle = {
    right: -9,
    zIndex: 2,
    backgroundColor: "transparent",
    padding: "0px",
    width: "14px",
    height: "14px",
    cursor: "pointer",
    position: "absolute",
    left: `${position.prex - 7 + position.x}px`,
    top: `${position.prey - 8 + position.y}px`,
  };

  const handleStop = (e, data) => {
    setSpecialField(false)
    const updatedCoordinates = {
      "x-coordinate": (position.prex + data.x) / scale,
      "y-coordinate": (position.prey + data.y) / scale,
      // "x-coordinate": Math.floor((position.prex + data.x) / scale),
      // "y-coordinate": Math.floor((position.prey + data.y) / scale),
    };
    const variableName =
      dragBoxDetails?.variableName || currVariable?.variableName;
    console.log("variable name is:", variableName);
    const { width, height } = boxSize || {};
    const xCoord = updatedCoordinates["x-coordinate"] * scale;
    const yCoord = updatedCoordinates["y-coordinate"] * scale;
    if (variableName) {
      let isSpecialVariable;
      if (variableName?.includes(".")) {
        isSpecialVariable = [
          "Add Stamp",
          "Dynamic Stamp",
          "Multi Signer Stamp",
          "digital_stamp",
          "watermark_image",
          "multi_signers",
        ].includes(variableName?.split(".")[0]);
      } else {
        isSpecialVariable = [
          "Add Stamp",
          "Dynamic Stamp",
          "Multi Signer Stamp",
          "digital_stamp",
          "watermark_image",
          "multi_signers",
        ].includes(variableName);
      }

      // console.log("variable name isspecialvariable", isSpecialVariable);
      // console.log("variable name iswidthpdf", widthPdf);
      // console.log("variable name isxcoord", xCoord, "width", width);
      const adjustedHeightPdf = isSpecialVariable
        ? heightPdf - heightPdf * 0.07
        : heightPdf;
      const adjustedWidthPdf = isSpecialVariable
        ? widthPdf - widthPdf * 0.07
        : widthPdf;
      if (
        adjustedWidthPdf < xCoord + width ||
        xCoord < 0 ||
        yCoord < 0 ||
        adjustedHeightPdf < yCoord + height
      ) {
        // toast.error("outside");
        toast.error(
          "Coordinate should stay within the PDF previewer area when dragging."
        );
        // Reset position to prevent moving out of bounds
        setPosition({
          x: 0,
          y: 0,
          prex: parseInt(coordinate["x-coordinate"]) * scale,
          prey: parseInt(coordinate["y-coordinate"]) * scale,
          // prex: Math.floor(parseInt(coordinate["x-coordinate"]) * scale),
          // prey: Math.floor(parseInt(coordinate["y-coordinate"]) * scale),
        });
        onSelect(); // Ensure box is selected on drag stop
      } else {
        dispatch(
          updateCoordinate({ id: coordinate.id, newValue: updatedCoordinates })
        );
        setIsPosition(true);
        onSelect(); // Ensure box is selected on drag stop
      }
    } else {
      console.log("else xcord and ycord are", xCoord, yCoord, width, height);
      if (
        widthPdf < xCoord + width ||
        widthPdf < 0 ||
        xCoord < 0 ||
        yCoord < 0 ||
        heightPdf < yCoord + height
      ) {
        // toast.error("outside");
        toast.error(
          "Coordinate should stay within the PDF previewer area when dragging."
        );
        // Reset position to prevent moving out of bounds
        setPosition({
          x: 0,
          y: 0,
          prex: parseInt(coordinate["x-coordinate"]) * scale,
          prey: parseInt(coordinate["y-coordinate"]) * scale,
          // prex: Math.floor(parseInt(coordinate["x-coordinate"]) * scale),
          // prey: Math.floor(parseInt(coordinate["y-coordinate"]) * scale),
        });
        onSelect(); // Ensure box is selected on drag stop
      } else {
        dispatch(
          updateCoordinate({ id: coordinate.id, newValue: updatedCoordinates })
        );
        setIsPosition(true);
        onSelect(); // Ensure box is selected on drag stop
      }
      
    }
    

    // if (
    //   widthPdf < updatedCoordinates["x-coordinate"] * scale + boxSize?.width ||
    //   heightPdf - heightPdf * (5 / 100) <
    //     updatedCoordinates["y-coordinate"] * scale
    // ) {
    //   // if (
    //   //   widthPdf < updatedCoordinates["x-coordinate"] * scale + boxSize?.width ||
    //   //   updatedCoordinates["x-coordinate"] * scale < 0 ||
    //   //   (dragBoxDetails?.variableName === "AADHAR_NO" ||
    //   //   dragBoxDetails?.variableName === "Add Stamp" ||
    //   //   dragBoxDetails?.variableName === "Dynamic Stamp" ||
    //   //   dragBoxDetails?.variableName === "Multi Signer Stamp"
    //   //     ? heightPdf - heightPdf * (5 / 100)
    //   //     : heightPdf) <
    //   //     updatedCoordinates["y-coordinate"] * scale + boxSize?.height
    //   // )
    //   toast.error(
    //     "Coordinate should stay within the PDF previewer area when dragging."
    //   );
    //   // Reset position to prevent moving out of bounds
    //   setPosition({
    //     x: 0,
    //     y: 0,
    //     prex: parseInt(coordinate["x-coordinate"]) * scale,
    //     prey: parseInt(coordinate["y-coordinate"]) * scale,
    //   });
    // } else {
    //   dispatch(
    //     updateCoordinate({ id: coordinate.id, newValue: updatedCoordinates })
    //   );
    //   setIsPosition(true);
    // }
  };
  const handleDrag = (e, data) => {
    setPosition((prevPosition) => {
      const newPosition = {
        ...prevPosition,
        x: data.x,
        y: data.y,
      };

      return newPosition;
    });
  };

  // const throttledHandleDrag = useCallback(
  //   throttle((data) => {
  //     setPosition((prevPosition) => ({
  //       ...prevPosition,
  //       x: data.x,
  //       y: data.y,
  //     }));
  //   }, 100), // 100ms delay for smooth performance
  //   []
  // );

  // const handleDrag = (e, data) => {
  //   throttledHandleDrag(data); // Use throttled version of handleDrag
  // };

  useEffect(() => {
    setPosition({
      x: 0,
      y: 0,
      prex: parseInt(coordinate["x-coordinate"]) * scale,
      prey: parseInt(coordinate["y-coordinate"]) * scale,
      // prex: Math.floor(parseInt(coordinate["x-coordinate"]) * scale),
      // prey: Math.floor(parseInt(coordinate["y-coordinate"]) * scale),
    });
  }, [coordinate, scale]);

  return (
    <Wrapper>
      { isSelected && (
      // {currVariable?.variable === coordinate.id && !isAddTextEnabled && (
        <SelectField
          items={coordinate}
          scale={scale}
          position={position}
          setDragBoxDetails={setDragBoxDetails}
          setSelectedVariable={setSelectedVariable}
          settedFontSize={coordinate?.fontSize}
          settedFontSpace = {coordinate?.fontSpace}
          settedBoxHeight = {coordinate?.height}
          settedBoxWidth = {coordinate?.width}
          setSpecialField={setSpecialField}
          multiField={multiField}
          setMultiField={setMultiField}
          setSelectedBoxId={setSelectedBoxId}
        />
      )}
      {/* <Tooltip arrow placement="top" title="Delete">
        <Icon
          onClick={() => {setMultiField(false);handleDeleteVariable(coordinate.id)}}
          style={iconStyle}
          icon="bitcoin-icons:cross-filled"
          onMouseEnter={() => {
            if(multiField){
              return;
            }
            // setFlag(false);
            handleSelectBox(coordinate);
          }}
          // onMouseLeave={() => setFlag(true)}
        />
      </Tooltip> */}
      {isSelected ? (
      // {isDraggingEnabled ? (
        <Resizable
          disabled
          onMouseEnter={() => {
            if(multiField){
            // if(multiField || clickFlag){
              return;
            }
            // setFlag(true)
            handleSelectBox(coordinate);
            onSelect();
          }}
          onMouseLeave={() => {
            if(multiField){
              return;
            }
            // handleMouseLeave();
            onSelect();
          }}
          onClick={() => {
            setMultiField(false);
            setActive(true);
            // setClickFlag((prev) => !prev)
            handleSelectBoxClick(coordinate);
            onSelect();
          }}
          style={{
            backgroundColor:
              currVariable?.variable === coordinate.id && "transparent",
            // : "#ccc",
            position: "absolute",
            left: `${position.prex}px`,
            top: `${position.prey}px`,

            border:
              currVariable?.variable === coordinate.id
                ? "1px dashed #000"
                : !coordinate.value
                ? "2px solid red"
                : "1px solid #000",
            cursor: "pointer",
            letterSpacing: currVariable?.fontSpace,
            fontSize: currVariable?.fontSize,
            textAlign: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            zIndex:3,
          }}
          bounds="parent"
          size={{ height: coordinate?.height, width: coordinate?.width }}
          onResizeStop={handleResizeStop}
          onResizeStart={()=>{ 
            let checkSpecial = checkSpecialOrNot()
            if(checkSpecial){
              setSpecialField(true)
            }}}
          className="item"
        >
          <Typography sx={{ fontSize: coordinate?.fontSize, letterSpacing:coordinate?.fontSpace }}>
            {coordinate?.value}
          </Typography>
        </Resizable>
      ) :  (
        <Draggable
          nodeRef={nodeRef}
          onDrag={handleDrag}
          position={position}
          onMouseEnter={() => {
            handleSelectBox(coordinate);
          }}
          onStart={() => {
            let checkSpecial = checkSpecialOrNot()
            if(checkSpecial){
              setSpecialField(true)
            }
            console.log("is special", checkSpecial);
            // setFlag(true);
            handleSelectBox(coordinate);
          }}
          onStop={handleStop}
          bounds=""
          onClick={()=>handleSelectBox(coordinate)}
          style={{
            position: "relative",
            zIndex:"3 !important",
          }}
        >
          <Box
            ref={nodeRef}
            style={{
              position: "absolute",
              left: `${position.prex}px`,
              top: `${position.prey}px`,
              border:
                currVariable?.variable === coordinate.id
                  ? "1px dashed #000"
                  : !coordinate.value
                  ? "2px solid red"
                  : "1px solid #000",
              cursor: "move",
              height: coordinate.height,
              width: coordinate.width,
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              transition: "all 0.1s ease-out",
              zIndex:3,
            }}
          >
            <Typography sx={{ fontSize: coordinate?.fontSize, letterSpacing:coordinate?.fontSpace }}>
              {coordinate?.value}
            </Typography>
          </Box>
        </Draggable>
        
      )}
    </Wrapper>
  );
};

export default CustomBox;

const Wrapper = styled.div`
  .item div div {
    height: 4px !important;
    width: 4px !important;
  }

  .item div > div:nth-child(5) {
    height: 4px !important;
    width: 4px !important;
    right: 0px !important;
    bottom: 0px !important;
  }
  .item div > div:nth-child(6) {
    height: 4px !important;
    width: 4px !important;
    right: 0px !important;
    bottom: 0px !important;
  }
`;
